
import { mapGetters, mapActions, mapState } from "vuex"
import AppFooter from "@soenergy/frontend-library/src/components/AppFooter"
import HeaderContainer from "@/components/HeaderContainer"
import GlobalBanner from "@soenergy/frontend-library/src/components/GlobalBanner"
import CookieManager from "@soenergy/frontend-library/src/components/CookieBanner/CookieManager"
import * as CookieConsentPlugin from "@soenergy/frontend-library/src/services/CookieConsentPlugin"
import { footerNavItems } from "@soenergy/frontend-library/src/config/footerNavItems"

export default {
  name: "DefaultLayout",
  components: {
    HeaderContainer,
    GlobalBanner,
    AppFooter,
    CookieManager
  },
  async fetch() {
    await this.fetchLayoutContent()
  },
  data: () => ({
    isLinkedToMarketingSite:
      process.env.VUE_APP_LINKED_TO_MARKETING_SITE === "true",
    footerNavItems
  }),
  computed: {
    ...mapGetters("contentManagement", [
      "header",
      "footer",
      "globalBanner",
      "cookieModal",
      "cookieBanner",
      "maintenanceBanner"
    ]),
    ...mapState({
      featureData: state => state.userStatus.featureData,
      userStatus: state => state.userStatus.userStatus,
      isProspectSwitchJourneyEnabled: state =>
        state.contentManagement.isProspectSwitchJourneyEnabled,
      isPromoteRenewalEnabled: state =>
        state.contentManagement.isPromoteRenewalEnabled,
      isWebsiteBeMaintenanceEnabled: state =>
        state.contentManagement.isWebsiteBeMaintenanceEnabled
    }),
    bannerContent() {
      const isMaintenanceBannerEnabled = this.maintenanceBanner?.enabled

      return isMaintenanceBannerEnabled
        ? this.maintenanceBanner
        : this.globalBanner
    }
  },
  created() {
    if (process.client) {
      this.$store.dispatch("userStatus/fetchFeatureData", {
        useLegacyAuthentication: false
      })
      this.$store.dispatch("userStatus/fetchUserStatus", {
        useLegacyAuthentication: false
      })
    }
  },
  async mounted() {
    // For layouts, the fetch function is not called in production builds when using preview
    const isStaticBuildInPreview =
      this.$nuxt.isPreview && !this.$nuxt.context.isDev
    if (isStaticBuildInPreview) {
      await this.fetchLayoutContent()
    }
  },
  methods: {
    ...mapActions("contentManagement", ["fetchLayoutContent"]),
    reopenCookieModal() {
      if (this.$config.isThirdPartyCookieConsentEnabled) {
        CookieConsentPlugin.openPreferencesModal()
      } else {
        this.$refs.CookieManager.showModal()
      }
    }
  }
}
